import { Button } from '@eventbrite/eds-button';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    EB_ADS_AVAILABLE_IN_GEOS,
    PLAN_DONOT_AD_SPENDS,
} from '../constants/main';
import './featuresComparison.scss';
import { getOrganizerFeePerPlan } from './pricingAndPackagingUtils';

const _getFooterPlanText = (planText: string | GenericLazyString) => {
    return (
        <div>
            <p>{planText.split('at')[0] + 'at'}</p>
            <p>
                <strong>{planText.split('at')[1]}</strong>
            </p>
        </div>
    );
};

const _getFreeFlexProLink = (isAuthenticated: boolean) => {
    let link = '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
    if (isAuthenticated) {
        link = '/manage/events/create/';
    }
    return link;
};

const _renderFooterButtonTab = (
    labelText: string | GenericLazyString | React.ReactNode,
    buttonText: string | GenericLazyString | React.ReactNode,
    style: string,
    hrefLink: string,
    labelStrong: boolean,
) => {
    const labelStrongClassName = !labelStrong ? '' : 'cpp-footer-boldtext';

    return (
        <>
            <div>
                <p className={labelStrongClassName}>{labelText}</p>
            </div>
            <Button href={hrefLink} style={style} type="link" target="_blank">
                {buttonText}
            </Button>
        </>
    );
};

const PricePlanComparisionFooterTab: FunctionComponent<{
    isAuthenticated: boolean;
    isSmallScreen: boolean;
    planIndex: any;
}> = ({ isAuthenticated, isSmallScreen, planIndex }) => {
    const COMPARE_PKG_FOOTER_ROW_CLASS_NAME = classNames(
        'eds-g-grid',
        'eds-l-pad-hor-4',
        'marketing-container__max-width',
    );

    const planTitleClasses = classNames(
        'eds-text--left eds-g-offset-0-12 eds-g-offset-mw-1-12 eds-g-cell eds-g-cell-6-12',
        'eds-g-cell-mn-4-12 eds-g-cell-mw-3-12 eds-g-cell-ln-3-12 eds-g-cell-lg-3-12 eds-g-cell-lw-3-12',
    );

    const comparePackageFooterClasses = classNames(
        'eds-text--center eds-g-cell eds-g-cell-mn-2-12 eds-g-cell-md-2-12',
        'eds-g-cell-mw-2-12 eds-g-cell-ln-2-12 eds-g-cell-lg-2-12 eds-g-cell-lw-2-12',
        !isSmallScreen ? 'eds-g-cell-6-12' : 'eds-g-cell-12-12',
    );

    const FOOTER_LINE_CONTAINER_CLASS_NAME =
        'eds-g-group eds-l-pad-vert-3 eds-l-pad-top-3 eds-align--center-vertical cpp-align-bottom';
    const FOOTER_LINE_MOBILE_CONTAINER_CLASS =
        'eds-g-group eds-l-pad-vert-3 eds-l-pad-top-3 eds-align--center cpp-mobile-btn';

    const priceMapping = getOrganizerFeePerPlan();

    const freeButton = _renderFooterButtonTab(
        gettext('Custom'),
        gettext('Get Free'),
        'neutral',
        _getFreeFlexProLink(isAuthenticated),
        true,
    );

    const flexButton = _renderFooterButtonTab(
        _getFooterPlanText(priceMapping[1]),
        gettext('Get Flex'),
        'fill',
        _getFreeFlexProLink(isAuthenticated),
        false,
    );

    const proButton = _renderFooterButtonTab(
        _getFooterPlanText(priceMapping[2]),
        gettext('Get Pro'),
        'neutral',
        _getFreeFlexProLink(isAuthenticated),
        false,
    );

    const salesButton = _renderFooterButtonTab(
        gettext('Custom'),
        gettext('Contact Sales'),
        'neutral',
        '/l/contact-eventbrite-sales/',
        true,
    );

    const footerButtons = [freeButton, flexButton, proButton, salesButton];

    if (!isSmallScreen) {
        return (
            <div className="eds-footer-flex">
                <div className={COMPARE_PKG_FOOTER_ROW_CLASS_NAME}>
                    <div className={FOOTER_LINE_CONTAINER_CLASS_NAME}>
                        <div className={planTitleClasses}>
                            <p className="eds-text-color--grey-600">
                                <i>{PLAN_DONOT_AD_SPENDS}</i>
                            </p>
                            <p className="eds-text-color--grey-600 eds-l-pad-top-3 ">
                                <i>{EB_ADS_AVAILABLE_IN_GEOS}</i>
                            </p>
                        </div>
                        <div className={comparePackageFooterClasses}>
                            {freeButton}
                        </div>
                        <div className={comparePackageFooterClasses}>
                            {flexButton}
                        </div>
                        <div className={comparePackageFooterClasses}>
                            {proButton}
                        </div>
                        <div className={comparePackageFooterClasses}>
                            {salesButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="eds-footer-flex">
                <div className={COMPARE_PKG_FOOTER_ROW_CLASS_NAME}>
                    <div className={FOOTER_LINE_MOBILE_CONTAINER_CLASS}>
                        <div className={comparePackageFooterClasses}>
                            {footerButtons[planIndex]}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default PricePlanComparisionFooterTab;
